export const environment = {
  production: false,
  ENV: 'qa',
  BASEDOMAIN: 'qa-api.edulinksolutions.com',
  BASEURI: 'https://qa-api.edulinksolutions.com',
  FIREBASECONFIG: {
    apiKey: "AIzaSyC6Oyps1jsm38LpaAEMHiq4KapSZJZZ5ls",
    authDomain: "edl-identity.firebaseapp.com"
  },
  FIREBASE_TENANT: ""
};
